import { createFileRoute } from '@tanstack/react-router';

import { InspectionPerformPage } from '@/features/quality/perform-page';

export const Route = createFileRoute('/_app/projects/$projectId/safety/walks/$inspectionId')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId, inspectionId } = Route.useParams();
  return (
    <InspectionPerformPage projectId={projectId} inspectionId={inspectionId} category="safety" />
  );
}
